import { setupListeners } from "@reduxjs/toolkit/dist/query";
import { configureStore } from "@reduxjs/toolkit";
import modalReducer from "./slice/modalSlice";
import globalReducer from "./slice/globalSlice";
import { api } from "../api/redux/api";

export const store = configureStore({
  reducer: {
    global: globalReducer,
    modal: modalReducer,
    [api.reducerPath]: api.reducer,
  },
  middleware: (getDefault) =>
    getDefault({ serializableCheck: false }).concat([api.middleware]),
});

setupListeners(store.dispatch);

export type StoreDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
